module.exports = __webpack_public_path__ + "assets/75da9ea3e424a64859e1d7243720b4b4.png";